import { observer } from 'mobx-react';
import { useEffect } from 'react';

import AnimationDocument from 'stores/Animation';
import CreativeDocument from 'stores/Creative';
import type ProjectStore from 'stores/Project';
import store from 'stores/RootStore';

import AddDocumentButton from '../../UI/AddDocument/AddDocumentButton';
import DocumentFolderView from '../../UI/DocumentFolderView/DocumentFolderView';

const PROJECT_VIEW_TITLE = 'Project';

interface ProjectContentProps {
  project?: ProjectStore | undefined;
  documentTitle?: string;
}

function ProjectContent({ project, documentTitle }: ProjectContentProps) {
  useEffect(() => {
    document.title = documentTitle || PROJECT_VIEW_TITLE;
  }, [documentTitle]);

  return (
    <DocumentFolderView
      childrenTableTitle="Documents"
      parentDocument={project}
      childrenTableHeaderButtons={
        project && (
          <>
            <AddDocumentButton
              parentDocument={project}
              documentType={CreativeDocument}
              documentTypeName="Creative"
            />
            <AddDocumentButton
              parentDocument={project}
              documentType={AnimationDocument}
              documentTypeName="Animation"
            />
          </>
        )
      }
    />
  );
}

function Project() {
  return (
    <ProjectContent
      project={store.project}
      documentTitle={store.current?.data?.name}
    />
  );
}

export default observer(Project);
